import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { Logo } from "@/components/Logo";

const SOCIALS = [
  { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61595458445635", Icon: Facebook, testid: "social-facebook-link" },
  { label: "Instagram", href: "https://www.instagram.com/brolbaas/", Icon: Instagram, testid: "social-instagram-link" },
  { label: "TikTok", href: "https://www.tiktok.com/@brolbaas", testid: "social-tiktok-link", Icon: (p) => (
      <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/></svg>
    ) },
];

export default function Footer() {
  return (
    <footer id="contact" className="relative overflow-hidden border-t border-white/10" data-testid="contact-footer">
      <div className="hazard-stripes h-3 w-full" aria-hidden="true" />
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-20">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Logo height={96} />
            <p className="mt-5 font-display text-xl font-extrabold uppercase tracking-wide text-safety" data-testid="footer-tagline">
              Geen rommel. Geen gedoe.
            </p>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-muted2">
              Professionele ophaaldienst voor huisafval, meubels, woningontruiming en tuinafval.
              Snel, netjes en met oog voor recycling.
            </p>
            <div className="mt-8 flex gap-3" data-testid="social-links">
              {SOCIALS.map(({ label, href, Icon, testid }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={testid}
                  className="flex h-11 w-11 items-center justify-center border border-white/15 text-muted2 transition-colors duration-200 hover:border-brand hover:text-brand"
                >
                  <Icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>
          <div className="lg:col-span-7">
            <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-safety">Contact</h3>
            <ul className="mt-6 space-y-4">
              <li>
                <a href="tel:+32487588585" className="flex items-center gap-3 text-paper transition-colors hover:text-brand" data-testid="contact-phone-link">
                  <Phone className="h-4 w-4 text-brand" /> +32 487 58 85 85
                </a>
              </li>
              <li>
                <a href="mailto:brol-baas@hotmail.com" className="flex items-center gap-3 text-paper transition-colors hover:text-brand" data-testid="contact-email-link">
                  <Mail className="h-4 w-4 text-brand" /> brol-baas@hotmail.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-muted2" data-testid="contact-region">
                <MapPin className="h-4 w-4 text-brand" /> Actief in heel België
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
          <p className="font-mono text-xs uppercase tracking-[0.15em] text-muted2" data-testid="footer-copy">
            © 2026 Brol Baas. — Alles wat weg moet, halen wij weg.
          </p>
          <a href="/admin/login" className="font-mono text-xs uppercase tracking-[0.15em] text-muted2/60 transition-colors hover:text-paper" data-testid="admin-login-link">
            Beheerder
          </a>
        </div>
      </div>
    </footer>
  );
}
